import { Component, OnInit, OnDestroy } from "@angular/core";
import { HttpBaseService } from "../services/httpBase.service";
import api from "../api";
import { getCrossBrowserElement, getClientWidth } from "../service";
import * as utils from "../services/comment";
import {
  GetStore,
  GetSessionStore,
  SetSessionStore,
  RemoveStore
} from "../services/comment";
import { TabName, News } from "../class";
import { NzMessageService, NzModalService } from "ng-zorro-antd";
import { Router, NavigationEnd } from "@angular/router";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.less", "../style/skin1.less", "../style/skin2.less"]
})
export class MainComponent implements OnInit {
  data2: Array<object>;
  data1: Array<object>;
  collectList: Array<object>;
  ssoList: Array<object>;
  sysCount: number;
  selectedIndex: number;
  processSelectedIndex: number;
  isVisible = false;
  setInterTime: any;
  allCollect: Array<object>;
  processTabs: Array<object>;
  todoTasksData: [Array<object>];
  todoTaskLoading: boolean = true;
  notifyTasksData: Array<object>;
  bpmListsData: Array<object>;
  allCollectList: Array<object>;
  collectArr: Array<any>;
  newsArr: Array<object>;
  noticeArr: Array<object>;
  functionsso: string;
  functionssoCollection: string;
  userName: any;
  user: any;
  bpmListsIsSpinning: Boolean = true;
  todoIsSpinning: Boolean;
  notifyIsSpinning: Boolean = true;
  successLoginInfo: any;
  languageList:Array<string>;
  certificate: string;
  ssoStyle: any;
  ssoListLi: any;
  systemNameList: Array<string>;
  menuCode: object = {};
  moreLink: string = "";

  constructor(
    private http: HttpBaseService,
    public tab: TabName,
    private _msg: NzMessageService,
    private router: Router,
    private confirmServ: NzModalService,
    public newsData: News
  ) {
    this.data1 = this.newsData.data1;
    this.data2 = this.newsData.data2;
    this.selectedIndex = 0;
    this.processSelectedIndex = 0;
    this.systemNameList = ["SAM"];
    this.bpmListsIsSpinning = true;
    this.todoIsSpinning = true;
    this.notifyIsSpinning = true;
  }

  ngOnInit() {
    this.getInt();



  }

  // 切换待办、待阅、我的流程
  processTabsChang(tab?) {

    let index = tab ? tab.index : 0;

    let p = ''
    switch (index) {
      case 0:
        p = 'DB'
        break;
      case 1:
        p = 'DY'
        break;
      case 2:
        p = 'WDLC'
        break;
      default:
        console.error('没有')
        break;
    }

    if (this.menuCode[p]) {
      let _urlobj = {
        name: this.menuCode[p].menuName,
        url: this.menuCode[p].htmlUrl.replace('/', ''),
        id: this.menuCode[p].menuId,
        code:this.menuCode[p].menuCode || p,
        active: true
      }

      this.moreLink = `/frame/#/oa/main?formPortal=${encodeURIComponent(JSON.stringify(_urlobj))}`;
    }

  }
  getInt() {
    this.functionsso = api.functionsso;
    this.functionssoCollection = api.functionssoCollection;
    this.successLoginInfo = JSON.parse(GetStore("successLoginInfo"));
    this.userName = this.successLoginInfo.userName;
    this.certificate = this.successLoginInfo["certificate"];
    this.languageList = this.successLoginInfo["languageList"];
    SetSessionStore("certificate", this.certificate);
    let ssoList = this.successLoginInfo;
    //默认
    let icon = [
      { icon: "iconfont icon-a536", bg: "icon-cycle crm-bg" },
      { icon: "iconfont icon-erp", bg: "icon-cycle erp-bg" },
      { icon: "iconfont icon-yuangong", bg: " icon-cycle ess-bg" },
      { icon: "iconfont icon-serverrole", bg: " icon-cycle bi-bg" },
      { icon: "iconfont icon-tiaoma1", bg: "icon-cycle code-bg" },
      { icon: "iconfont icon-tiaoma1", bg: "icon-cycle code-bg" },
      { icon: "iconfont icon-tiaoma1", bg: "icon-cycle code-bg" },
      { icon: "iconfont icon-tiaoma1", bg: "icon-cycle code-bg" },
      { icon: "iconfont icon-tiaoma1", bg: "icon-cycle code-bg" },
      { icon: "iconfont icon-tiaoma1", bg: "icon-cycle code-bg" },
      { icon: "iconfont icon-tiaoma1", bg: "icon-cycle code-bg" },
      { icon: "iconfont icon-tiaoma1", bg: "icon-cycle code-bg" },
    ];
    // 获取系统列表
    let hostName = window.location.host;

    if (ssoList.ssoSystems !== undefined) {
      this.ssoList = ssoList.ssoSystems;
      this.sysCount = this.ssoList.length;
      const _w = getClientWidth('sso');
      this.ssoStyle = { 'width': _w + 'px' }
      const itemMin = _w / 6;

      this.ssoListLi = { 'width': itemMin + 'px' }
      console.log('ssoStyle:' + JSON.stringify(this.ssoStyle));
      console.log('ssoListLi:' + JSON.stringify(this.ssoListLi));
      console.log(this.ssoList.length)
      if (this.ssoList.length > 6) {
        this.ssoStyle = { 'width': itemMin * this.ssoList.length + 'px' }
      };
      this.ssoList.map((item, key) => {
        item["icon"] = icon[key].icon;
        item["select"] = false;
        item["bg"] = icon[key].bg;
        item["url"] = `${api.ssoLink}${item["systemCode"]}/${
          this.certificate
          }?path=${window.location.protocol}%2f%2f${hostName}`;
        this.systemNameList.push(item["systemCode"]);
      });
    }
    this.alreadyCollect();
    this.getAllCollect();
    this.getCollect();
    // this.getNews();
    this.interval();
    // this.findTodoTasks();
    // this.findBpmLists();
    // this.findNotifyTasks();
  }
  showModal() {
    this.getAllCollect();
    this.isVisible = true;
  }

  // 检测是否被登录。。
  interval() {
    this.setInterTime = setInterval(() => {
      if (GetStore("successLoginInfo")) {
        this.user = JSON.parse(GetStore("successLoginInfo")).userName;
      } else {
        utils.RemoveALL();
        clearInterval(this.setInterTime);
        window.location.href = "/";
        this.getInt()
      }

      if (!utils.Cookies.getCookie('sessionTime')) {
        utils.RemoveALL();
        clearInterval(this.setInterTime);
        window.location.href = "/";
      } else {
        console.log(' 运行中..... ');
      }
      // 同一页面登入退出另一个帐号
      if (this.user !== this.userName) {
        SetSessionStore('successLoginInfo', GetStore("successLoginInfo"))
        window.location.reload();
        // 退出操作

      }
    }, 3000)


  }
  getNews() {
    // console.log(this.ssoList);
    // 获取新闻列表
    this.http
      .post(api.findNews, {
        pageIndex:1,
        pageRows:6,
        params: JSON.stringify({
          systemCode: this.systemNameList.join(","),
          isAdmin: this.successLoginInfo["isadmin"]
        })
      })
      .subscribe(res => {
        if (res.status === "S") {
          this.newsArr = res.data;

        }
      });

    this.http
      .post(api.findNotice, {
        pageIndex:1,
        pageRows:6,
        params: JSON.stringify({
          systemCode: this.systemNameList.join(","),
          isAdmin: this.successLoginInfo["isadmin"]
        })
      })
      .subscribe(res => {
        if (res.status === "S") {
          this.noticeArr = res.data;
        }
      });
  }
  findTodoTasks() {
    //流程待办任务查询
    this.http
      .post(api.findTodoTasks, {

        pageRows: '5'
      })
      .subscribe(res => {
        if (res.status === "S") {
          // this.todoTasksData = res.data;

          this.createHerfList(res.data, 'DB');

          this.todoIsSpinning = false
        } else {
          this.todoIsSpinning = true;
        }
      });
  }


  //跳转到详情
  /*  goJump(_urlobj: object, url?: string) {
     let host = window.location.host
     let headTab = 'OA_headTab';
     let certificate = 'OA_certificate';
     let successLoginInfo = 'OA_successLoginInfo';
     sessionStorage[headTab] = utils.Base64.encode(JSON.stringify(_urlobj));
     sessionStorage[certificate] = sessionStorage.getItem('certificate');
     sessionStorage[successLoginInfo] = sessionStorage.getItem('successLoginInfo');
     localStorage[successLoginInfo] = sessionStorage.getItem('successLoginInfo');

     let a = document.getElementById("maingolink")
     let _url = '//' + host + '/frame/#/oa/main'
     a.setAttribute('href', _url)
     a.click()

   } */

  //创建列表的真实url
  createHerfList(list, type) {
    let taskIds = [];
    let listIds = [];
    let param = {}
    let urlApi = api.getTaskUrlByTaskIds;

    if (type === 'DB' || type === 'DY') {
      list.map((data) => {
        taskIds.push(data.taskId)
      })

      param = {
        taskIds: taskIds
      }
    } else if (type === 'WDLC') {

      list.map((data) => {
        listIds.push(data.listId)
      })

      param = {
        listIds: listIds
      }
      urlApi = api.getStartUrlByListIds
    }

    this.findMenuData(type).subscribe(menuData => {

      if (list.length === 0) {
        if (type === 'DB') {
          this.todoTaskLoading = false;
        } else if (type === 'DY') {

          this.notifyIsSpinning = false;
        } else if (type === 'WDLC') {

          this.bpmListsIsSpinning = false;
        }
        return;
      }

      if(!menuData.data || menuData.data.length===0){
        //没有获取OA菜单的信息，当前职责没有OA 的访问权限
        this.todoTaskLoading = false;
        return;

      }
      let menu = menuData.data[0];
      this.menuCode[type] = menu;

      if (type === 'DB') {
        this.processTabsChang(); // 创建待审批的 更多 链接
      }
      this.http
        .post(urlApi, {
          params: JSON.stringify(param)
        })
        .subscribe(res => {
          list.map(item => {
            for (let n = 0; n < res.data.length; n++) {
              let node = res.data[n];
              if (item.taskId === node.taskId) {
                let _urlobj: any = {};
                let menucode;
                let url = decodeURIComponent(node.url);

                let menuReg = /menucode=[a-z_\-\d]+/gim;
                let menuMatch = url.match(menuReg);

                if (menuMatch) {
                  menucode = menuMatch[0].replace('menucode=', '');
                  url = url.replace(menuReg, '');
                } else {
                  menucode = type;
                }

                _urlobj = {
                  name: '待审批流程：' + item.bpm_title,
                  id: menu.menuId,
                  code: menucode,
                }

                switch (type) {
                  case 'DB':
                    if (node.isStart === true) { // 草稿
                      _urlobj.url = 'showProcess/' + url + '&action=refusal&from=portal'

                    } else {

                      _urlobj.url = 'showProcess/' + url + '&action=approval&from=portal'

                    }
                    break;

                  case 'DY':
                    _urlobj.url = 'showProcess/' + url + '&action=unread&from=portal'
                    break;
                  case 'WDLC':


                    if (item.status === -1) { // 草稿
                      _urlobj.url = 'showProcess/' + url + '&action=draft&from=portal'
                      _urlobj.name = '编辑流程：' + item.title

                    } else if (item.status === 1) { // 审批通过
                      _urlobj.name = '流程详情：' + item.title
                      _urlobj.url = 'showProcess/' + url + '&action=detail&from=portal'

                    } else if (item.status === 0 && node.isStart === true) { // 审批驳回
                      _urlobj.url = 'showProcess/' + url + '&action=refusal&from=portal'
                      _urlobj.name = '审批驳回：' + item.title

                    } else if (node.status === 0 && node.isStart === false) { // 审批中
                      _urlobj.name = '流程详情：' + item.title
                      _urlobj.url = 'showProcess/' + url + '&action=detail&from=portal'
                    }
                    break
                }


                item.href = `/frame/#/oa/main?formPortal=${encodeURIComponent(JSON.stringify(_urlobj))}`;
                break;
              }
            }
          })


          if (type === 'DB') {
            this.todoTasksData = list;
            this.todoTaskLoading = false;
          } else if (type === 'DY') {
            this.notifyTasksData = list;
            this.notifyIsSpinning = false;
          } else if (type === 'WDLC') {
            debugger;
            this.bpmListsData = list;
            this.bpmListsIsSpinning = false;
          }


        })



    })



    /*
       list.map((data, index) => {

         let p = {}
         let _urlobj = []
         switch (type) {
           case 0://待办
           case 1://待阅
             p = {
               taskId: data.taskId
             };
             break;
           case 2://我的流程
             p = {
               listId: data.listId
             };
             break;
         }
         if (type < 2) {
           this.http
             .post(api.getTaskUrl, {
               params: JSON.stringify(p)
             })
             .subscribe(res => {
               if (res.status === "S") {
                 let menucode;
                 let url = decodeURIComponent(res.data.url);

                 let menuReg = /menucode=[a-z_\-\d]+/gim;
                 let menuMatch = url.match(menuReg);

                 if (menuMatch) {
                   menucode = menuMatch[0].replace('menucode=', '');
                   url = url.replace(menuReg, '');
                 }

                 switch (type) {
                   case 0://待办
                     this.findMenuData('DB').subscribe(menuData => {
                       let menu = menuData.data[0];
                       debugger;
                       if (res.data.isStart === true) { // 草稿
                         _urlobj = [{
                           name: '审批驳回：' + data.bpm_title,
                           url: 'showProcess/' + url + '&action=refusal&from=portal',
                           active: true,
                           id: menu.menuId,
                           code: menucode,
                           version: new Date().getTime()
                         }]

                       } else {
                         _urlobj = [{
                           name: '待审批流程：' + data.bpm_title,
                           url: 'showProcess/' + url + '&action=approval&from=portal',
                           active: true,
                           id: menu.menuId,
                           code: menucode,
                           version: new Date().getTime()
                         }]

                       }
                       // this.goJump(_urlobj);
                       data.menuObj = _urlobj;

                     })
                     break;
                   case 1://待阅
                     this.findMenuData('DY').subscribe(menuData => {
                       let menu = menuData.data[0];
                       _urlobj = [{
                         name: '待审批流程：' + data.bpm_title,
                         url: 'showProcess/' + url + '&action=unread&from=portal',
                         active: true,
                         id: menu.menuId,
                         code: menucode,
                         version: new Date().getTime(),
                         isParent: true
                       }]

                       // this.goJump(_urlobj);
                       data.menuObj = _urlobj;
                     })
                     break;
                 }
               }
             });
         }
         if (this.processSelectedIndex == 2) {
           this.http
             .post(api.getStartUrl, {
               params: JSON.stringify(p)
             })
             .subscribe(res => {
               if (res.status === "S") {
                 this.findMenuData('WDLC').subscribe(menuData => {
                   let menu = menuData.data[0];
                   let menucode;
                   let url = decodeURIComponent(res.data.url);

                   let menuReg = /menucode=[a-z_\-\d]+/gim;
                   let menuMatch = url.match(menuReg);

                   if (menuMatch) {
                     menucode = menuMatch[0].replace('menucode=', '');
                     url = url.replace(menuReg, '');
                   }

                   if (data.status === -1) { // 草稿
                     _urlobj = [{
                       name: '编辑流程：' + data.title,
                       url: 'showProcess/' + url + '&action=draft&from=portal',
                       active: true,
                       id: menu.menuId,
                       code: menucode,
                       version: new Date().getTime(),
                       isParent: true
                     }]
                   } else if (data.status === 1) { // 审批通过
                     _urlobj = [{
                       name: '流程详情：' + data.title,
                       url: 'showProcess/' + url + '&action=detail&from=portal',
                       active: true,
                       id: menu.menuId,
                       code: menucode,
                       version: new Date().getTime(),
                       isParent: true
                     }]
                   } else if (data.status === 0 && res.data.isStart === true) { // 审批驳回
                     _urlobj = [{
                       name: '审批驳回：' + data.title,
                       url: 'showProcess/' + url + '&action=refusal&from=portal',
                       active: true,
                       id: menu.menuId,
                       isParent: true,
                       code: menucode,
                     }]
                   } else if (data.status === 0 && res.data.isStart === false) { // 审批中
                     _urlobj = [{
                       name: '流程详情：' + data.title,
                       url: 'showProcess/' + url + '&action=detail&from=portal',
                       active: true,
                       id: menu.menuId,
                       code: menucode,
                       version: new Date().getTime(),
                       isParent: true
                     }]
                   }
                   // this.goJump(_urlobj);
                   data.menuObj = _urlobj;
                 })
               }
             });

         }
       })

       console.log(list);
        */
  }
  findMenuData(meunCode) {
    return this.http
      .post(api.findMenuList, {
        params: JSON.stringify({ "menuCode": meunCode, "systemCode": "OA" })
      })

  }
  findNotifyTasks() {
    //流程待阅任务查询
    this.http
      .post(api.findNotifyTasks, {
        params: JSON.stringify({ 'status': 0 }),
        pageRows: '5'
      })
      .subscribe(res => {
        if (res.status === "S") {
          // this.notifyTasksData = res.data;
          this.createHerfList(res.data, 'DY');
          // this.notifyIsSpinning = false;
        } else {
          this.notifyIsSpinning = true;
        }
      });
  }
  findBpmLists() {
    //我的流程
    this.http
      .post(api.findBpmLists, {
        pageRows: '5'
      })
      .subscribe(res => {
        if (res.status === "S") {
          // this.bpmListsIsSpinning = false;
          // this.bpmListsData = res.data;

          this.createHerfList(res.data, 'WDLC');

        } else {
          this.bpmListsIsSpinning = true;
        }
      });
  }
  getAllCollect() {
    // 获取全部收藏夹列表
    this.http
      .post(api["collectFind"], {
        params: JSON.stringify({ addFlag: true })
      })
      .subscribe(res => {
        if (res.status === "S") {

          this.allCollect = res.data;
        }
      });
  }
  getCollect() {
    // 获取全部收藏夹列表
    this.http
      .post(api["findMenuListAll"], {})
      .subscribe(res => {
        if (res.status === "S") {
          this.allCollectList = res.data;
        }
      });
  }
  alreadyCollect() {
    // 获取收藏夹列表
    this.http
      .post(api.collectFind, {
        params: JSON.stringify({})
      })
      .subscribe(res => {
        if (res.status === "S") {
          this.collectList = res.data;
          this.collectList.map(item => {
            //item["url"] = `${api.functionsso}/${
            //  item["functionCollectionUserId"]
            //}`;
            item["url"] = `${api.functionsso}/${
              item["functionCollectionId"]
              }`;
          });
          console.log(this.collectList)
        } else {
          RemoveStore("successLoginInfo");
          window.location.href = "/";
        }
      });
  }

  favorite(data: object) {
    this.collectArr = [];
    if (!data["isCollect"]) {
      data["isCollect"] = true;
    } else {
      data["isCollect"] = !data["isCollect"];
    }
    this.allCollect.map(item => {
      if (item["isCollect"]) {
        this.collectArr.push(item["functionCollectionId"]);
      }
    });
  }

  // 弹出框提交
  handleOk() {
    this.http
      .post(api.addCollection, {
        params: JSON.stringify({
          functionCollectionId: this.collectArr.join(",")
        })
      })
      .subscribe(res => {
        if (res.status === "S") {
          this.isVisible = false;
          // this.collectList = res.data;
          this.alreadyCollect();
          this._msg.success("成功");
        }
      });
  }
  // 弹出框取消
  handleCancel(e) {
    this.isVisible = false;
  }

  // 删除收藏夹
  _deleteCol(id: number) {
    this.http
      .post(api.deleteUserCollection, {
        params: JSON.stringify({
          id: id
        })
      })
      .subscribe(res => {
        if (res.status === "S") {
          this.alreadyCollect();
          this._msg.success("删除成功");
        }
      });
  }

  confirm(id: number) {
    this._deleteCol(id);
  }

  more() {
    // this.router.navigate([`newslist/${type}`]);
    switch (this.selectedIndex) {
      case 0://新闻
        window.open(`/#/newslist/NOTICE`);
        break;
      case 1://公告
        window.open(`/#/newslist/NEWS`);
        break;
    }
    // window.open(`/#/newslist/${type}`);
  }
  linkTo(data) {
    // this.router.navigate([`news/${data.articleId}`]);
    window.open(`/#/news/${data.articleId}`);
  }
  cursorTitle(event, title) {
    event.target.setAttribute('title', title);
  }
  mouseoverItem(index) {
    this.ssoList[index]['select'] = true
  }
  mouseoutItem(index) {
    this.ssoList[index]['select'] = false
  }
  mouseover(event, className) {
    const _sys = 6;
    // 小于6个系鼠标统悬浮无反应
    if (this.sysCount < _sys) {
      return;
    }

    // 大于6个系统悬浮移动
    let position = getCrossBrowserElement(event);
    let _class = document.querySelector("." + className);

    let _more = this.sysCount - _sys;
    const _w = getClientWidth(className) / 2;
    position.x = position.x - 20;
    position.y = position.y - 100;
    const _offset = 16.66667 * _more;
    if (position.x > _w) {
      _class["style"].left = `-${_offset}%`;
    } else {
      _class["style"].left = "0";
    }
  }
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/main/main.component.ts